<div class="dynamic-tables">
  <ng-container
    *ngIf="sections.length"
    [formGroup]="mainForm"
    locktonAppsFormGroupValidation
    #mainFormValidation="validation"
  >
    <div class="w-100 break-inside-avoid">
      <div class="d-flex mb-1 mt-2 align-items-center d-print-none">
        <strong *ngIf="props.label">
          {{ props.label }}
        </strong>
        <mat-button-toggle-group
          *ngIf="!props.readonly"
          class="ms-auto"
          formControlName="_fillWith"
        >
          <mat-button-toggle
            class="dynamic-tables__relation-button bold d-flex justify-content-center align-items-center"
            value="currency"
          >
            {{ props.currency }}
          </mat-button-toggle>
          <mat-button-toggle
            class="dynamic-tables__relation-button bold d-flex justify-content-center align-items-center"
            value="percentage"
          >
            %
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div>
        <div
          *ngFor="let section of sections"
          class="dynamic-tables__row d-flex py-2 px-2"
          [ngClass]="{
            'dynamic-tables__row--revert':
              mainForm.get('_fillWith')?.value === 'percentage'
          }"
        >
          <div class="dynamic-tables__key bold">{{ section.label }}</div>
          <div class="dynamic-tables__value">
            <ng-container
              *ngIf="mainForm.get('_fillWith')?.value === 'currency'"
            >
              <div>
                <mat-form-field
                  [formGroupName]="section.id"
                  [class.mat-mdc-form-field-readonly]="props.readonly"
                >
                  <div matPrefix class="ps-1">{{ props.currency }}</div>
                  <mat-label>{{ props.currencyFieldLabel }}</mat-label>
                  <input
                    [locktonAppsClearOnFocus]="
                      props.readonly ? 'disabled' : props.clearInputOnFocus
                    "
                    [readonly]="props.readonly"
                    [id]="[section.fieldPath, '_declaredValue'] | join : '.'"
                    matInput
                    type="text"
                    min="0"
                    formControlName="_declaredValue"
                    currencyMask
                  />
                  <mat-error>
                    {{
                      mainFormValidation.getMessageForControl([
                        section.id,
                        '_declaredValue'
                      ])
                    }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div>
                <div class="d-flex flex-column">
                  <span>{{ props.percentageFieldLabel }}</span>
                  <span>
                    {{
                      percentageForm.get([section.id, '_declaredValue'])?.value
                        | round : 2
                    }}%
                  </span>
                </div>
              </div>
            </ng-container>

            <ng-container
              *ngIf="mainForm.get('_fillWith')?.value === 'percentage'"
            >
              <div>
                <div
                  [formGroup]="percentageForm"
                  locktonAppsFormGroupValidation
                  #percentageFormValidation="validation"
                >
                  <mat-form-field
                    [formGroupName]="section.id"
                    [class.mat-mdc-form-field-readonly]="props.readonly"
                  >
                    <div matSuffix class="ps-1">%</div>
                    <mat-label>
                      {{ props.percentageFieldLabel }}
                    </mat-label>
                    <input
                      [locktonAppsClearOnFocus]="
                        props.readonly ? 'disabled' : props.clearInputOnFocus
                      "
                      formControlName="_declaredValue"
                      [readonly]="props.readonly"
                      [id]="[section.fieldPath, '_declaredValue'] | join : '.'"
                      matInput
                      type="number"
                      min="0"
                      max="100"
                    />
                    <mat-error>
                      {{
                        percentageFormValidation.getMessageForControl([
                          section.id,
                          '_declaredValue'
                        ])
                      }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div>
                <div class="d-flex flex-column">
                  <span>{{ props.currencyFieldLabel }}</span>
                  <span>
                    {{ props.currency }}
                    {{
                      mainForm.get([section.id, '_declaredValue'])?.value
                        | round : 2
                        | mask : 'separator' : { thousandSeparator: ',' }
                    }}
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
          <lui-avatar
            *ngIf="section.tooltip"
            color="primary"
            class="dynamic-tables__tooltip d-print-none"
            [size]="20"
            [matTooltip]="section.tooltip.text"
            [useClickListener]="true"
          >
            <mat-icon svgIcon="i"></mat-icon>
          </lui-avatar>
        </div>
      </div>

      <div
        class="dynamic-tables__row dynamic-tables__row--summary d-flex p-2"
        [ngClass]="{
          'dynamic-tables__row--revert':
            mainForm.get('_fillWith')?.value === 'percentage'
        }"
      >
        <div class="dynamic-tables__key">{{ props.totalLabel }}</div>
        <div class="dynamic-tables__value dynamic-tables__total mat-h4">
          <div>
            {{ props.currency }}
            {{ totals.currency | currency : 'GBP' : '' }}
          </div>
          <div>{{ totals.percentage | round : 2 }} %</div>
        </div>
      </div>

      <div
        *ngIf="props.totalRequirements"
        class="dynamic-tables__row dynamic-tables__row--summary d-flex p-2"
        [ngClass]="{
          'dynamic-tables__row--revert':
            mainForm.get('_fillWith')?.value === 'percentage',
          'dynamic-tables__row--error': formControl.hasError(
            'mustAddUpRequiredAmount'
          )
        }"
      >
        <div class="dynamic-tables__key">
          <p>{{ props.totalRequirements.label }}</p>
          <div class="dynamic-tables__key-description pe-1">
            {{ props.totalRequirements.description }}
          </div>
        </div>
        <div class="dynamic-tables__value dynamic-tables__total mat-h4">
          <div>
            <ng-container
              *ngIf="
                props.totalRequirements.value;
                else noTotalRequirementsValueTmpl
              "
            >
              {{ props.currency }}
              {{
                props.totalRequirements.value | currency : 'GBP' : '' : '1.2'
              }}
            </ng-container>
          </div>
          <div>100%</div>
        </div>
      </div>

      <mat-error>
        <formly-validation-message [field]="field"></formly-validation-message>
      </mat-error>
    </div>

    <ng-container *ngFor="let section of sections">
      <section
        class="dynamic-tables__section pt-4 mt-4"
        *ngIf="
          (section.fields || section.table) &&
          mainForm.get(section.id)?.value._declaredValue > 0
        "
      >
        <ng-container *ngIf="section.table">
          <div class="d-flex justify-content-between">
            <h3 class="mat-h3">{{ section.label }}</h3>
            <ng-container *ngIf="!section.description && section.table.tooltip">
              <ng-container
                *ngTemplateOutlet="
                  tooltipTmpl;
                  context: { $implicit: section.table.tooltip.text }
                "
              ></ng-container>
            </ng-container>
          </div>

          <div
            *ngIf="section.description"
            class="dynamic-tables__section-description mt-2 d-flex justify-content-between"
          >
            {{ section.description }}
            <ng-container *ngIf="section.table.tooltip">
              <ng-container
                *ngTemplateOutlet="
                  tooltipTmpl;
                  context: { $implicit: section.table.tooltip.text }
                "
              ></ng-container>
            </ng-container>
          </div>

          <div class="w-100 break-inside-avoid" [formGroupName]="section.id">
            <div class="d-flex justify-content-between mb-1 mt-2">
              <span *ngIf="section.table.description">
                {{ section.table.description }}
              </span>

              <mat-button-toggle-group
                *ngIf="!props.readonly"
                formControlName="_fillWith"
              >
                <mat-button-toggle
                  class="dynamic-tables__relation-button bold d-flex justify-content-center align-items-center"
                  value="currency"
                >
                  {{ props.currency }}
                </mat-button-toggle>
                <mat-button-toggle
                  class="dynamic-tables__relation-button bold d-flex justify-content-center align-items-center"
                  value="percentage"
                >
                  %
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>

            <div>
              <div
                *ngFor="let field of section.table.fields"
                class="dynamic-tables__row d-flex py-2 px-2"
                [ngClass]="{
                  'dynamic-tables__row--revert':
                    mainForm.get(section.id)?.value._fillWith === 'percentage'
                }"
              >
                <div class="dynamic-tables__key pe-2 bold">
                  {{ field.label }}
                </div>
                <div class="dynamic-tables__value">
                  <ng-container
                    *ngIf="
                      mainForm.get(section.id)?.value._fillWith === 'currency'
                    "
                  >
                    <div>
                      <mat-form-field>
                        <div matPrefix class="ps-1">{{ props.currency }}</div>
                        <mat-label>{{ props.currencyFieldLabel }}</mat-label>
                        <input
                          [locktonAppsClearOnFocus]="
                            props.readonly
                              ? 'disabled'
                              : props.clearInputOnFocus
                          "
                          [formControlName]="field.id"
                          [readonly]="props.readonly"
                          matInput
                          type="text"
                          min="0"
                          currencyMask
                        />
                        <mat-error>
                          {{
                            mainFormValidation.getMessageForControl([
                              section.id,
                              field.id
                            ])
                          }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div>
                      <div class="d-flex flex-column">
                        <span>{{ props.percentageFieldLabel }}</span>
                        <span>
                          {{
                            percentageForm.get([section.id, field.id])?.value
                              | round : 2
                          }}%
                        </span>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container
                    *ngIf="
                      mainForm.get(section.id)?.value._fillWith === 'percentage'
                    "
                  >
                    <div>
                      <div
                        [formGroup]="percentageForm"
                        locktonAppsFormGroupValidation
                        #percentageFormValidation="validation"
                      >
                        <mat-form-field [formGroupName]="section.id">
                          <div matPrefix class="ps-1">%</div>
                          <mat-label>
                            {{ props.percentageFieldLabel }}
                          </mat-label>
                          <input
                            [locktonAppsClearOnFocus]="
                              props.readonly
                                ? 'disabled'
                                : props.clearInputOnFocus
                            "
                            [formControlName]="field.id"
                            [readonly]="props.readonly"
                            matInput
                            type="number"
                            min="0"
                            max="100"
                          />
                          <mat-error>
                            {{
                              percentageFormValidation.getMessageForControl([
                                section.id,
                                field.id
                              ])
                            }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div>
                      <div class="d-flex flex-column">
                        <span>{{ props.currencyFieldLabel }}</span>
                        <span>
                          {{ props.currency }}
                          {{
                            mainForm.get([section.id, field.id])?.value
                              | round : 2
                              | mask : 'separator' : { thousandSeparator: ',' }
                          }}
                        </span>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <div
              class="dynamic-tables__row dynamic-tables__row--summary d-flex p-2"
              [ngClass]="{
                'dynamic-tables__row--revert':
                  mainForm.get(section.id)?.value._fillWith === 'percentage',
              }"
            >
              <div class="dynamic-tables__key pe-2">{{
                section.summary.label
              }}</div>
              <div
                *ngIf="
                  mainForm.get(section.id)?.value
                    | sectionSummary
                      : (section.table.fields | mapPipe : 'id') as summary
                "
                class="dynamic-tables__value dynamic-tables__total mat-h4"
              >
                <div>
                  {{ props.currency }}
                  {{
                    $any(summary.amount | number : '1.2')
                      | mask : 'separator' : { thousandSeparator: ',' }
                  }}
                </div>
                <div>{{ summary.percentage }}%</div>
              </div>
            </div>
            <div
              class="dynamic-tables__row dynamic-tables__row--summary d-flex p-2"
              [ngClass]="{
                'dynamic-tables__row--revert':
                  mainForm.get(section.id)?.value._fillWith === 'percentage',
                'dynamic-tables__row--error': mainForm
                  .get(section.id)
                  ?.hasError('mustAddUpTotal')
              }"
            >
              <div
                *ngIf="section.summary.breakdownLabel"
                class="dynamic-tables__key pe-2"
              >
                {{ section.summary.breakdownLabel }}
              </div>
              <div class="dynamic-tables__value dynamic-tables__total mat-h4">
                <div>
                  {{ props.currency }}
                  {{
                    $any(
                      mainForm.get(section.id)?.value?._declaredValue
                        | number : '1.2'
                    ) | mask : 'separator' : { thousandSeparator: ',' }
                  }}
                </div>
                <div>100%</div>
              </div>
            </div>
            <mat-error>
              <ng-container
                *ngIf="mainForm.get(section.id)?.hasError('mustAddUpTotal')"
              >
                All amounts must add up to total. Please check each amount is
                entered correctly.
              </ng-container>
            </mat-error>
          </div>
        </ng-container>

        <formly-form
          *ngIf="section.fields"
          [form]="$any(mainForm.get(section.id + '.additionalData'))"
          [fields]="section.fields"
        ></formly-form>
      </section>
    </ng-container>
  </ng-container>
</div>

<ng-template #tooltipTmpl let-text>
  <lui-avatar
    color="primary"
    class="dynamic-tables__tooltip d-print-none ms-1"
    size="20px"
    [matTooltip]="text"
    [useClickListener]="true"
  >
    <mat-icon svgIcon="i"></mat-icon>
  </lui-avatar>
</ng-template>

<ng-template #noTotalRequirementsValueTmpl>
  <span class="mat-small text-danger" i18n>undefined</span>
</ng-template>
